import { DME, DMEData } from "dmeditor";
import { nanoid } from "nanoid";
import { EntityVideoJS } from "./entity";
import { config } from "./config";

const definition: DME.Widget = {
  category: "basic",
  icon: "video",
  name: "Video Pro",
  widgetType: "widget",
  type: "videojs",
  events: {
    createBlock: (): DMEData.Block<EntityVideoJS> => {
      return {
        id: nanoid(),
        type: "videojs",
        style: { theme: "city" },
        data: {
          type: "file",
          src: "https://samplelib.com/lib/preview/mp4/sample-5s.mp4",
          settings: {
            general: {
              width: "60%",
              align: "center",
            },
          },
        },
      };
    },
    updateData: () => {},
  },
  settings: [
    {
      name: "Video type",
      property: ".type",
      settingComponent: "select",
      parameters: {
        options: config.videoTypes.map((item) => {
          return { label: item.label, value: item.value };
        }),
      },
    },
    {
      name: "Source url",
      property: ".src",
      settingComponent: "input",
      parameters: { updateOnUnfocus: true },
    },
  ],
};

export default definition;
